import './description.scss'

const desc =  <article className='description__content'>
Hi. it's me, Mada. <br/> Here are some projects I’ve worked on and skills I have aquired.
</article>

function Description(){
return(
<section className='description '>
  {desc}
</section>
)
}
 export default Description
